import { render, staticRenderFns } from "./LinkQR015.vue?vue&type=template&id=3645c1f6&scoped=true&"
import script from "./LinkQR015.vue?vue&type=script&lang=js&"
export * from "./LinkQR015.vue?vue&type=script&lang=js&"
import style0 from "./LinkQR015.vue?vue&type=style&index=0&id=3645c1f6&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3645c1f6",
  null
  
)

export default component.exports